import React, { useState } from "react";
import Events from "../components/Programs/Events";
import Aside from "../modules/SideNav/Aside";

function EventsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
                rtl={rtl}
                toggled={toggled}
                handleToggleSidebar={handleToggleSidebar}
            /> */}
      <Events handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default EventsLayout;
